"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _get2 = _interopRequireDefault(require("lodash-es/get"));

var _button = _interopRequireDefault(require("../../atoms/button"));

var _buttonGroup = _interopRequireDefault(require("../button-group"));

var _overlay = _interopRequireDefault(require("../../atoms/overlay"));

var _icon = _interopRequireDefault(require("../../atoms/icon"));

var _link = _interopRequireDefault(require("../../atoms/link"));

var _heading = _interopRequireDefault(require("../../atoms/heading"));

var _enhancedOverlay = _interopRequireDefault(require("./_enhancedOverlay"));

var _tokens = require("../../../tokens");

var _versions = require("../../_utils/versions");

var _context = require("../../context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: ", ";\n  min-height: ", "px;\n  padding: 14px 32px;\n  box-sizing: border-box;\n  align-items: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: ", " ", ";\n  overflow: auto;\n  border-top: ", ";\n  border-bottom: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  overflow: hidden;\n  height: ", "px;\n  box-sizing: border-box;\n  padding: ", ";\n  color: ", ";\n  background: ", ";\n  font-weight: ", ";\n  > div, span {\n    margin: 0;\n    flex: 1;\n  }\n  & ", " {\n    flex: none;\n    cursor: pointer;\n    height: auto;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: ", "px;\n  background: ", ";\n  border-radius: ", ";\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3), 0 0 0 rgba(0, 0, 0, 0.1);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  s: 432,
  m: 660,
  l: 888,
  xl: 1116
};
var defaults = {
  titleHeight: 70
};

var getColors = function getColors(props) {
  var dialogColors = (0, _versions.getColor)(props, 'dialog');
  var textColors = (0, _versions.getColor)(props, 'text');
  return {
    dialogColors: dialogColors,
    textColors: textColors
  };
};

var createButtonForActions = function createButtonForActions(action, index) {
  var label = action.label,
      buttonProps = _objectWithoutProperties(action, ["label"]);

  return _react["default"].createElement(_button["default"], _extends({
    key: index
  }, buttonProps), label);
};

var defaultConfig = {
  disabled: false,
  view: 'default',
  loading: false
};

var DialogAction = function DialogAction(label, method) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultConfig;

  _classCallCheck(this, DialogAction);

  this.label = label;
  this.onClick = method;
  this.disabled = config.disabled;
  this.view = config.view;
  this.loading = config.loading;
};

var Dialog = function Dialog(props) {
  var disableBgScroll = props.disableBgScroll,
      version = props.version,
      bottomBorder = props.bottomBorder,
      topBorder = props.topBorder,
      titleHeight = props.titleHeight,
      footerHeight = props.footerHeight,
      bodyClass = props.bodyClass,
      footerComponent = props.footerComponent,
      footerClass = props.footerClass,
      footerAlign = props.footerAlign;
  var OverlayComponent = disableBgScroll ? _enhancedOverlay["default"] : _overlay["default"];
  return _react["default"].createElement(OverlayComponent, props, _react["default"].createElement(Dialog.Element, props, _react["default"].createElement(Dialog.TitleBar, {
    version: version,
    titleHeight: titleHeight
  }, _react["default"].createElement(_heading["default"], {
    size: 2
  }, props.title), _react["default"].createElement(_link["default"], {
    onClick: props.onClose
  }, _react["default"].createElement(_icon["default"], {
    name: "close",
    size: 16
  }))), _react["default"].createElement(Dialog.Body, {
    className: bodyClass,
    version: version,
    bottomBorder: bottomBorder,
    topBorder: topBorder
  }, props.children), _react["default"].createElement(Dialog.Footer, {
    footerHeight: footerHeight,
    footerComponent: footerComponent,
    footerAlign: footerAlign
  }, footerComponent && _react["default"].createElement(FooterComponent, {
    className: footerClass
  }, footerComponent), _react["default"].createElement(_buttonGroup["default"], null, props.actions.map(createButtonForActions)))));
};

Dialog.Element = _styledComponents["default"].div(_templateObject(), function (props) {
  return (0, _get2["default"])(sizes, props.size, props.width);
}, function (props) {
  return getColors(props).dialogColors.background;
}, function (props) {
  return props.radius;
});
Dialog.TitleBar = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.titleHeight;
}, function (props) {
  if (props.titleHeight === defaults.titleHeight) {
    return '25px 32px 16px 32px';
  }

  return '16px 32px';
}, function (props) {
  return getColors(props).textColors["default"];
}, function (props) {
  return getColors(props).dialogColors.titleBackground;
}, _tokens.fonts.weight.medium, _icon["default"].Element);
Dialog.Body = _styledComponents["default"].div(_templateObject3(), _tokens.spacing.medium, _tokens.spacing.xlarge, function (props) {
  return props.topBorder && "1px solid ".concat(getColors(props).dialogColors.headerBorder);
}, function (props) {
  return props.bottomBorder && "1px solid ".concat(getColors(props).dialogColors.headerBorder);
});
Dialog.Footer = _styledComponents["default"].div(_templateObject4(), function (props) {
  return props.footerComponent && props.footerAlign === 'left' ? 'space-between' : 'flex-end';
}, function (props) {
  return props.footerHeight;
});

var FooterComponent = _styledComponents["default"].div(_templateObject5(), function (props) {
  return props.footerAlign === 'left' && 1;
});

Dialog.Action = DialogAction;
Dialog.propTypes = {
  actions: _propTypes["default"].arrayOf(_propTypes["default"].instanceOf(DialogAction)).isRequired,
  title: _propTypes["default"].string.isRequired,
  width: _propTypes["default"].number,
  onClose: _propTypes["default"].func,

  /** Disable the background scrolling when dialog opens */
  disableBgScroll: _propTypes["default"].bool,
  bottomBorder: _propTypes["default"].bool,
  topBorder: _propTypes["default"].bool,
  radius: _propTypes["default"].string,
  titleHeight: _propTypes["default"].number,
  footerHeight: _propTypes["default"].number,
  backdropShade: _propTypes["default"].oneOf(['light', 'dark']),
  size: _propTypes["default"].oneOf(['s', 'm', 'l', 'xl']),
  footerAlign: _propTypes["default"].oneOf(['left', 'right']),
  bodyClass: _propTypes["default"].string,
  footerClass: _propTypes["default"].string,

  /** Additional footer component: can be string or react component */
  footerComponent: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element])
};
Dialog.defaultProps = {
  width: 500,
  disableBgScroll: false,
  bottomBorder: false,
  topBorder: true,
  radius: '3px',
  titleHeight: 70,
  footerHeight: 70,
  footerAlign: 'left',
  backdropShade: 'dark'
};
Dialog.displayName = 'Dialog';

var _default = (0, _context.withVersion)(Dialog);

exports["default"] = _default;